import { MAILTO_HREF } from "@/lib/constants";

export default function Hero({
  image,
  imageAlt,
  eyebrow,
  title,
  subtitle,
  ctaLabel = "Get In Touch",
  ctaHref = MAILTO_HREF,
  size = "large",
}) {
  const heightClass = size === "large" ? "min-h-[85vh]" : "min-h-[45vh]";

  return (
    <section className={`relative flex ${heightClass} items-center justify-center overflow-hidden bg-charcoal`}>
      <img
        src={image}
        alt={imageAlt}
        className="absolute inset-0 h-full w-full object-cover"
        fetchpriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/40" />

      <div className="section-container relative z-10 py-24 text-center">
        {eyebrow && (
          <p className="mb-4 font-display text-sm uppercase tracking-[0.3em] text-brick-light animate-fade-in-up">
            {eyebrow}
          </p>
        )}
        <h1 className="mx-auto max-w-4xl font-display text-4xl font-semibold leading-tight text-offwhite sm:text-5xl md:text-6xl animate-fade-in-up">
          {title}
        </h1>
        {subtitle && (
          <p
            className="mx-auto mt-6 max-w-2xl text-lg text-offwhite/80 animate-fade-in-up"
            style={{ animationDelay: "0.1s" }}
          >
            {subtitle}
          </p>
        )}
        {ctaLabel && (
          <div className="mt-10 animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
            <a
              href={ctaHref}
              className="inline-block rounded bg-brick px-8 py-4 font-display text-base uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
            >
              {ctaLabel}
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
